// extracted by mini-css-extract-plugin
export default {"IconHolder":"HomeTabIcon_IconHolder__tuxbr","Selected":"HomeTabIcon_Selected__0uGbU","Text":"HomeTabIcon_Text__QXBvf"};